module.exports = __webpack_public_path__ + "static/ic_no_campaign@2x.d021d048.png";